//import PatientCard from "../../components/PaitientCard/PatientCard";
import styles from "./PatientTrendAnalysis.scss";
//import ReortCharting from "../../components/ReportingChart/ReportingChart";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
//import "./ReportingChart.scss";
import { Row, Col } from "../../components/RowCol";
//import 'bootstrap/dist/css/bootstrap.min.css';
import {Table,Button} from 'react-bootstrap';
import { Accordion } from 'react-bootstrap-accordion'
import {Helmet} from "react-helmet";
import { Line } from 'react-chartjs-2';
import progressbar_1 from "../../assets/img/progressbar_1.PNG";
import progressbar_2 from "../../assets/img/progressbar_2.PNG";
import progressbar_3 from "../../assets/img/progressbar_3.PNG";
import progressbar_4 from "../../assets/img/progressbar_4.PNG";
import progressbar_5 from "../../assets/img/progressbar_5.PNG";


const data = [
  {
    title: "Last 3 Lab Tests",
    items: ["test1", "test2", "test3", "test1", "test2", "test3"],
    tag: "ailments_symptoms",
  },
  {
    title: "Last 3 Doctor's visits",
    items: ["Doctor 1", "Doctor 2", "Doctor 3"],
    tag: "ailments_symptoms",
  },
  {
    title: "Last 3 prescriptions",
    items: ["Prescription 1", "Prescription 2", "Prescription 3"],
    tag: "ailments_symptoms",
  },
  {
    title: "Last 3 clinic visits",
    items: ["Clinic", "Clinic", "Clinic"],
    tag: "ailments_symptoms",
  },
  {
    title: "Last 3 Procedures",
    items: ["Procedures", "Procedures", "Procedures"],
    tag: "ailments_symptoms",
  },
  {
    title: "Top 3 Reminders",
    items: ["Reminders", "Reminders", "Reminders"],
    tag: "assistances_services",
  },
  {
    title: "Top 3 Recommendations",
    items: ["Recommendations", "Recommendations", "Recommendations"],
    tag: "assistances_services",
  },
  {
    title: "Top 3 Trends",
    items: ["Trends", "Trends", "Trends"],
    tag: "assistances_services",
  },
  {
    title: "Top 3 Predictions",
    items: ["Predictions", "Predictions", "Predictions"],
    tag: "assistances_services",
  },
  {
    title: "Upcoming Appointments",
    items: ["Appointments", "Appointments", "Appointments"],
    tag: "assistances_services",
  },
  {
    title: "My Dietic & Nutrition",
    items: ["Diet", "Diet", "Diet"],
    tag: "general_recommendations",
  },
  {
    title: "Suggested reading on Lifestyles",
    items: ["read", "read", "read"],
    tag: "general_recommendations",
  },
  {
    title: "My Alternate Treatments",
    items: ["Treatments", "Treatments", "Treatments"],
    tag: "general_recommendations",
  },

  {
    title: "My Health Focus",
    items: ["Focus", "Focus", "Focus"],
    tag: "general_recommendations",
  },
  {
    title: "My Health Checks",
    items: ["Checks", "Checks", "Checks"],
    tag: "general_recommendations",
  },
  {
    title: "My Household",
    items: ["Household", "Household", "Household"],
    tag: "preferences",
  },
  {
    title: "My Health Trail",
    items: ["Trail", "Trail", "Trail"],
    tag: "preferences",
  },
  {
    title: "My Orders",
    items: ["Orders", "Orders", "Orders"],
    tag: "preferences",
  },
  {
    title: "My Hospitals, Doctors & Clinics",
    items: ["Clinics", "Clinics", "Clinics"],
    tag: "preferences",
  },
  {
    title: "My Settings",
    items: ["Settings", "Settings", "Settings"],
    tag: "preferences",
  },
];

const PatientTrendAnalysis = ({ type,setSearchText }) => {
  const [cardData, setCardData] = useState(data);
  
  const handleFilter = (tag) => {
    if (tag === "all") {
      setCardData(data);
    } else {
      setCardData(data.filter((ele) => ele.tag === tag));
    }
  };

  return (
    <>
      <div >
        <div style={{paddingTop:"2rem", textAlign:"center"}}><h3 className={styles["page-title"]} >My Health Trends</h3>
          {/* <PillNav />class={styles["console-main"]}
          </> */}
        </div>
         {/* <PatientCard /> 
        <ReortCharting/> */}
      </div>
      
      <div id="accordion" class="mb-70">
              <div class="accordion-item ">
                <div class="accordion__header" data-toggle="collapse" data-target="#collapse3"  onClick={() => handleFilter("ailments_symptoms")}>
                  <a class="accordion__title" href="#">Glucose</a>
                </div>{/* <!-- /.accordion-item-header--> class="accordion__body" opened show*/}
                <div id="collapse3" class="collapse show" data-parent="#accordion">
                 
                  <div class="accordion__body health-dashboard-wrapper" >
                  <Row style={{marginTop:"30px"}}>
                <Col area="span 6" style={{border: "2px solid #76787a"}}>
                    <Table striped bordered hover size="sm">
                      <thead style={{ textAlign: "center",verticalAlign:"middle"}}>
                        <tr>
                          
                          <th>Date</th>
                          <th>Value <br></br>mg/dl</th>
                          <th>Reference Range</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      {/* style={{ background: "#ffffff"}} */}
                      <tbody > <tr>
                          <td>3 Aug 2021</td>
                          <td>93</td>
                          <td  style={{ textAlign: "center"}} ><img src={progressbar_1} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                      
                        </tr>
                        <tr>
                          <td>7 June 2021</td>
                          <td>120</td>
                          <td style={{ textAlign: "center"}} >   <img src={progressbar_3} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}} /></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="danger">Success</Button>
                            </span>
                          </td>
                        
                        </tr><tr>
                          <td>14 Apr 2021</td>
                          <td>88</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_2} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                      
                        </tr><tr>
                          <td>5 Mar 2021</td>
                          <td>85</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_4} alt="divider"style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                        
                        </tr>
                        <tr>
                          <td>2 Feb 2021</td>
                          <td>50</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_5} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="danger">Success</Button>
                            </span>
                          </td>
                        
                        </tr>
                        </tbody>
                    </Table>
                </Col>
                      
                  
                  <Col area="span 6" style={{border: "2px solid #76787a",marginLeft:"2%"}}> 
                  <Line
                      data={state}
                      options={{
                        title:{
                          display:true,
                          text:'Average Rainfall per month',
                          fontSize:20
                        },
                        legend:{
                          display:true,
                          position:'right'
                        }
                      }}
                    />
                  </Col>
          </Row>
                    </div>
                  {/* <!-- /.accordion-item-body--> */}
                </div>
              </div>{/* <!-- /.accordion-item--> */}
              <div class="accordion-item">
                <div class="accordion__header" data-toggle="collapse" data-target="#collapse1">
                  <a class="accordion__title" href="#">Globulin</a>
                </div>{/* <!-- /.accordion-item-header--> */}
                <div id="collapse1" class="collapse" data-parent="#accordion">
                <div class="accordion__body health-dashboard-wrapper">
                <Row style={{marginTop:"30px"}}>
                <Col area="span 6" style={{border: "2px solid #76787a"}}>
                    <Table striped bordered hover size="sm">
                      <thead style={{ textAlign: "center",verticalAlign:"middle"}}>
                        <tr>
                          
                          <th>Date</th>
                          <th>Value <br></br>mg/dl</th>
                          <th>Reference Range</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      {/* style={{ background: "#ffffff"}} */}
                      <tbody > <tr>
                          <td>3 Aug 2021</td>
                          <td>93</td>
                          <td  style={{ textAlign: "center"}} ><img src={progressbar_1} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                      
                        </tr>
                        <tr>
                          <td>7 June 2021</td>
                          <td>120</td>
                          <td style={{ textAlign: "center"}} >   <img src={progressbar_3} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}} /></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="danger">Success</Button>
                            </span>
                          </td>
                        
                        </tr><tr>
                          <td>14 Apr 2021</td>
                          <td>88</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_2} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                      
                        </tr><tr>
                          <td>5 Mar 2021</td>
                          <td>85</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_4} alt="divider"style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                        
                        </tr>
                        <tr>
                          <td>2 Feb 2021</td>
                          <td>50</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_5} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="danger">Success</Button>
                            </span>
                          </td>
                        
                        </tr>
                        </tbody>
                    </Table>
                </Col>
                      
                  
                  <Col area="span 6" style={{border: "2px solid #76787a",marginLeft:"2%"}}> 
                  <Line
                      data={state}
                      options={{
                        title:{
                          display:true,
                          text:'Average Rainfall per month',
                          fontSize:20
                        },
                        legend:{
                          display:true,
                          position:'right'
                        }
                      }}
                    />
                  </Col>
          </Row>
                    </div>
                </div>
              </div>{/* <!-- /.accordion-item--> */}
              <div class="accordion-item">
                <div class="accordion__header" data-toggle="collapse" data-target="#collapse7">
                  <a class="accordion__title" href="#">Sodium</a>
                </div>{/* <!-- /.accordion-item-header--> */}
                <div id="collapse7" class="collapse" data-parent="#accordion">
                  <div class="accordion__body">
                  <div class="accordion__body health-dashboard-wrapper">
                  <Row style={{marginTop:"30px"}}>
                <Col area="span 6" style={{border: "2px solid #76787a"}}>
                    <Table striped bordered hover size="sm">
                      <thead style={{ textAlign: "center",verticalAlign:"middle"}}>
                        <tr>
                          
                          <th>Date</th>
                          <th>Value <br></br>mg/dl</th>
                          <th>Reference Range</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      {/* style={{ background: "#ffffff"}} */}
                      <tbody > <tr>
                          <td>3 Aug 2021</td>
                          <td>93</td>
                          <td  style={{ textAlign: "center"}} ><img src={progressbar_1} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                      
                        </tr>
                        <tr>
                          <td>7 June 2021</td>
                          <td>120</td>
                          <td style={{ textAlign: "center"}} >   <img src={progressbar_3} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}} /></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="danger">Success</Button>
                            </span>
                          </td>
                        
                        </tr><tr>
                          <td>14 Apr 2021</td>
                          <td>88</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_2} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                      
                        </tr><tr>
                          <td>5 Mar 2021</td>
                          <td>85</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_4} alt="divider"style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                        
                        </tr>
                        <tr>
                          <td>2 Feb 2021</td>
                          <td>50</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_5} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="danger">Success</Button>
                            </span>
                          </td>
                        
                        </tr>
                        </tbody>
                    </Table>
                </Col>
                      
                  
                  <Col area="span 6" style={{border: "2px solid #76787a",marginLeft:"2%"}}> 
                  <Line
                      data={state}
                      options={{
                        title:{
                          display:true,
                          text:'Average Rainfall per month',
                          fontSize:20
                        },
                        legend:{
                          display:true,
                          position:'right'
                        }
                      }}
                    />
                  </Col>
          </Row>
                    </div>
                  </div>{/* <!-- /.accordion-item-body--> */}
                </div>
              </div>{/* <!-- /.accordion-item--> */}
              <div class="accordion-item">
                <div class="accordion__header" data-toggle="collapse" data-target="#collapse2">
                  <a class="accordion__title" href="#">Potassium</a>
                </div>{/* <!-- /.accordion-item-header--> */}
                <div id="collapse2" class="collapse" data-parent="#accordion">
                <div class="health-dashboard-wrapper">
                <Row style={{marginTop:"30px"}}>
                <Col area="span 6" style={{border: "2px solid #76787a"}}>
                    <Table striped bordered hover size="sm">
                      <thead style={{ textAlign: "center",verticalAlign:"middle"}}>
                        <tr>
                          
                          <th>Date</th>
                          <th>Value <br></br>mg/dl</th>
                          <th>Reference Range</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      {/* style={{ background: "#ffffff"}} */}
                      <tbody > <tr>
                          <td>3 Aug 2021</td>
                          <td>93</td>
                          <td  style={{ textAlign: "center"}} ><img src={progressbar_1} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                      
                        </tr>
                        <tr>
                          <td>7 June 2021</td>
                          <td>120</td>
                          <td style={{ textAlign: "center"}} >   <img src={progressbar_3} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}} /></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="danger">Success</Button>
                            </span>
                          </td>
                        
                        </tr><tr>
                          <td>14 Apr 2021</td>
                          <td>88</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_2} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                      
                        </tr><tr>
                          <td>5 Mar 2021</td>
                          <td>85</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_4} alt="divider"style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="success">Success</Button>
                            </span>
                          </td>
                        
                        </tr>
                        <tr>
                          <td>2 Feb 2021</td>
                          <td>50</td>
                          <td style={{ textAlign: "center"}} ><img src={progressbar_5} alt="divider" style={{ alignItems: "center",width:"85%",height:"12px"}}/></td>
                          <td style={{ textAlign: "center"}}> <span className="data-value-button">
                            <Button variant="danger">Success</Button>
                            </span>
                          </td>
                        
                        </tr>
                        </tbody>
                    </Table>
                </Col>
                      
                  
                  <Col area="span 6" style={{border: "2px solid #76787a",marginLeft:"2%"}}> 
                  <Line
                      data={state}
                      options={{
                        title:{
                          display:true,
                          text:'Average Rainfall per month',
                          fontSize:20
                        },
                        legend:{
                          display:true,
                          position:'right'
                        }
                      }}
                    />
                  </Col>
          </Row>
                    </div>
                </div>
              </div>{/* <!-- /.accordion-item--> */}
              
            </div>
    </>
  );
};

const Card = styled.div`
  background-color: white;
  border: 2px solid #d5d5d5;
  padding: 0.5rem;
  border-radius: 10px;
  flex-grow: 1;
  flex-basis: 46%;
  h6 {
    text-align: center;
    font-size: 1rem;
    margin-block: 3%;
  }
  ul {
    padding-left: 10%;
  }
  a {
    padding-left: 10%;
    color: #651fff !important;
  }
`;
const datapoints = [20, 50, 30, 20, 35, 40, 30, 20, 40, 30];
const state = {
  labels: ['Jan-2021', 'Feb-2021', 'Mar-2021',
           'Apr-2021', 'May-2021','Jun-2021','Jul-2021','Aug-2021','Sep-2021'],
           datasets: [
            {
                //label: 'Cubic interpolation (monotone)',
                label: 'WBC Count',
                data: datapoints,
                //borderColor: 'rgba(255, 0, 0)',
                borderColor: 'rgba(51, 0, 0, 0.8)',
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderWidth: 1.5,
                fill: false,
                //cubicInterpolationMode: 'monotone',
                tension: 0
            }
            /*, {
                label: 'Cubic interpolation',
                data: datapoints,
                borderColor: 'rgba(0, 0, 255)',
                borderWidth: 1.5,
                fill: false,
                tension: 0.4
            }, {
                label: 'Linear interpolation (default)',
                data: datapoints,
                borderColor: 'rgba(0, 128 ,0)',
                borderWidth: 1.5,
                fill: false
            }*/
        ]
}


const progressColors = {
  green: "#01A601",
  pink: "#E87971",
  blue: "#05C4E2",
  orange: "#F66220",
};

const Progress = styled.div`
  height: 0.6rem;
  background-color: #ccd0d2;
  display: grid;
  grid-template-columns: ${(props) => props.width} calc(
      100% - ${(props) => props.width}
    );
  border-radius: 50px;
  width: 100%;
  .progress-item {
    height: 0.6rem;
    background-color: ${({ color }) => progressColors[color]};
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-radius: 50px;
    span {
      font-size: 0.8rem;
      color: #94999c;
      margin-top: -3rem;
    }
  }
  .bg {
    width: 100%;
  }
`;
const ProgressBar = ({ color, width }) => {
  return (
    <Progress color={color} width={width}>
      <div className="progress-item">
        <span>{width}</span>
      </div>
      <div className="bg"></div>
    </Progress>
  );
};

export default PatientTrendAnalysis;
